<div
  class="scroll-y me-n5 pe-5"
  [ngClass]="!isDrawer ? 'h-300px h-lg-auto' : ''"
  data-kt-element="messages"
  data-kt-scroll="true"
  data-kt-scroll-activate="{default: false, lg: true}"
  data-kt-scroll-max-height="auto"
  [attr.data-kt-scroll-dependencies]="
    isDrawer
      ? '#kt_drawer_chat_messenger_header, #kt_drawer_chat_messenger_footer'
      : '#kt_header, #kt_toolbar, #kt_footer, #kt_chat_messenger_header, #kt_chat_messenger_footer'
  "
  [attr.data-kt-scroll-wrappers]="
    isDrawer
      ? '#kt_drawer_chat_messenger_body'
      : '#kt_content, #kt_chat_messenger_body'
  "
  [attr.data-kt-scroll-offset]="isDrawer ? '0px' : '-2px'"
>
  <ng-container *ngIf="(messages | async) as messagesList">
    <ng-container *ngIf="messagesList.length > 0">
      <ng-container *ngFor="let message of messagesList; let last = last; let i = index">
        <div
          [ngClass]="{
            'd-flex': true,
            'justify-content-start': message.person !== 'Person',
            'justify-content-end': message.person === 'Person'
          }"
          class="mb-3"
        >
          <div
            class="d-flex flex-column align-items"
            [ngClass]="message.person === 'Person' ? 'align-items-end' : 'align-items-start'"
          >
            <!-- Show person details only if the previous message is from a different person -->
            <ng-container *ngIf="i === 0 || messagesList[i - 1]?.person !== message.person">
              <div class="d-flex align-items-center mb-1">
                <!-- Icon for VoiceBot -->
                <ng-container *ngIf="message.person === 'VoiceBot'">
                  <div class="symbol symbol-25px symbol-circle d-flex align-items-center justify-content-center me-1">
                    <i class="fa-solid fa-head-side-gear fs-5 text-gray-700"></i>
                  </div>
                </ng-container>

                <!-- Icon for Person -->
                <ng-container *ngIf="message.person === 'Person'">
                  <div class="symbol symbol-25px symbol-circle d-flex align-items-center justify-content-center me-1">
                    <i class="fa-solid fa-head-side-headphones fs-5 text-gray-700"></i>
                  </div>
                </ng-container>

                <!-- Icon for AI -->
                <ng-container *ngIf="message.person === 'AI'">
                  <div class="symbol symbol-25px symbol-circle d-flex align-items-center justify-content-center me-1">
                    <i class="fa-solid fa-message-bot fs-5 text-gray-700"></i>
                  </div>
                </ng-container>

                <!-- Icon for SMS and SMSAPI -->
                <ng-container *ngIf="message.person === 'SMS' || message.person === 'SMSAPI'">
                  <div class="symbol symbol-25px symbol-circle d-flex align-items-center justify-content-center me-1">
                    <i class="fa-solid fa-message-sms fs-5 text-gray-700"></i>
                  </div>
                </ng-container>

                <!-- Default Icon for Other Persons -->
                <ng-container *ngIf="message.person !== 'VoiceBot' && message.person !== 'Person' && message.person !== 'AI'">
                  <div class="symbol symbol-25px symbol-circle d-flex align-items-center justify-content-center me-1">
                    <i class="fa-solid fa-user fs-5 text-gray-700"></i>
                  </div>
                </ng-container>

                <!-- Details for All Messages -->
                <div [ngClass]="message.person === 'Person' ? 'me-1' : 'ms-1'">
                  <span class="fs-6 fw-bold text-gray-900 me-1">
                    {{ message.person === 'VoiceBot' ? ('MESSAGES.VOICEBOT' | translate) : (message.person | translate) }}
                  </span>
                  <span class="text-muted fs-8">{{ message.created | timezoneDate }}</span>
                </div>
              </div>
            </ng-container>

            <!-- Message Bubble -->
            <div
              class="p-2 rounded fs-7 mb-2"
              [ngClass]="{
                'bg-light-primary': message.person === 'VoiceBot',
                'bg-light-success': message.person === 'Person',
                'bg-light-danger': message.person !== 'VoiceBot' && message.person !== 'Person'
              }"
            >
              {{ message.value }}
            </div>
          </div>
        </div>

        <!-- End of Conversation Badge -->
        <ng-container *ngIf="last">
          <div class="text-center mt-10">
            <span class="badge bg-light-warning text-dark">{{ 'MESSAGES.END_OF_CONVERSATION' | translate }}</span>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
</div>
